import { Button, Card, Col, Modal, Row } from 'antd';
import React from 'react';
import { useMedia } from 'react-use';
import { BREAKPOINTS } from '../../../common/constants';

const UserAlreadyExistModal = ({
  showModal = false,
  setShowModal,
  userAlreadyExist,
  handleAddExistingUser,
  setUserAlreadyExist,
}) => {
  const isDesktopViewport = useMedia(`(min-width: ${BREAKPOINTS.desktop}px)`);
  const handleCancel = () => {
    setShowModal(false);
    setUserAlreadyExist();
  };

  return (
    <>
      <Modal
        open={showModal}
        centered
        footer={null}
        closable={false}
        wrapClassName="user-already-exist-modal"
      >
        {userAlreadyExist && (
          <div className="existing-user-info">
            <h3>User already Exists</h3>
            <p>The details you entered match below user’s existing record.</p>
            <Card bordered className="existing-user-info-card">
              <div>
                <div>
                  <b>Name : </b> {userAlreadyExist?.name || '-'}
                </div>
                <div>
                  <b>Email : </b> {userAlreadyExist?.email || '-'}
                </div>
                <div>
                  <b>Mobile Number : </b>
                  {userAlreadyExist?.phoneNo || '-'}
                </div>
                <p>
                  Either keep the same details or enter different details to
                  create the user.
                </p>
              </div>
            </Card>
          </div>
        )}
        <Row
          justify={
            !userAlreadyExist?.isActive &&
            !userAlreadyExist?.isUserExistWithSameEmailAndPhone
              ? 'space-between'
              : 'center'
          }
          gutter={10}
        >
          {!userAlreadyExist?.isActive &&
            !userAlreadyExist?.isUserExistWithSameEmailAndPhone && (
              <Col span={isDesktopViewport ? 12 : 24}>
                <Button
                  disabled={false}
                  type="link"
                  shape="round"
                  onClick={() => {
                    handleAddExistingUser(true);
                  }}
                  className="fill-width"
                >
                  Update With Entered Details
                </Button>
              </Col>
            )}
          <Col span={isDesktopViewport ? 12 : 24}>
            <Button
              shape="round"
              className="save-button fill-width"
              type="primary"
              htmlType="submit"
              onClick={() => {
                handleAddExistingUser();
              }}
            >
              Add With Existing Details
            </Button>
          </Col>
        </Row>
        <div className="d-flex justify-center mt-10">
          <Button
            shape="round"
            className="cancel-button"
            onClick={handleCancel}
            disabled={false}
          >
            Cancel
          </Button>
        </div>
      </Modal>
    </>
  );
};

export default UserAlreadyExistModal;
